module.exports = __webpack_public_path__ + "img/top.d250c82e.jpg";